// extracted by mini-css-extract-plugin
export default {"container":"sphere_container__lz3vh","canvas":"sphere_canvas__FkUmO"};